/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTransferOwnershipDto } from '../../models/backend-transfer-ownership-dto';
import { BackendTransferOwnershipRequestDto } from '../../models/backend-transfer-ownership-request-dto';

export interface AccessProjectsTransferOwnershipCreate$FormData$Params {
  project_id: number;
  body: BackendTransferOwnershipRequestDto;
}

export function accessProjectsTransferOwnershipCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsTransferOwnershipCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTransferOwnershipDto>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsTransferOwnershipCreate$FormData.PATH, 'post');
  if (params) {
    rb.path('project_id', params.project_id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTransferOwnershipDto>;
    }),
  );
}

accessProjectsTransferOwnershipCreate$FormData.PATH = '/api/access/projects/{project_id}/transfer-ownership/';
